<template>
  <div class="col call-chat-sidebar topix-support-sidebar">
    <div class="card border-0 shadow-sm">
      <div class="card-body chat-body">
        <div class="chat-box">
          <div class="chat-left-aside">
            <div class="d-flex align-items-center mb-3">
              <div class="topix-support-sidebar-icon rounded-circle">
                <vue-feather :type="authorType === 'DRIVER' ? 'truck' : 'users'" size="20" />
              </div>
              <div class="flex-grow-1 ms-2">
                <div class="name f-w-600">{{ sidebarTitle }}</div>
                <div class="status small text-muted">{{ tickets.length }} tickets</div>
              </div>
            </div>

            <div class="people-list">
              <div class="search">
                <form class="theme-form" @submit.prevent>
                  <div class="form-group mb-0">
                    <div class="input-group">
                      <input
                        v-model.trim="search"
                        class="form-control"
                        type="text"
                        placeholder="Buscar usuario"
                      />
                      <span class="input-group-text"><i class="fa fa-search" /></span>
                    </div>
                  </div>
                </form>
              </div>

              <div v-if="loading" class="text-center py-4 text-muted small">Cargando tickets...</div>
              <div v-else-if="loadError" class="alert alert-danger mt-3 small">{{ loadError }}</div>
              <ul v-else class="list custom-scrollbar topix-ticket-list">
                <li
                  v-for="ticket in filteredTickets"
                  :key="ticket.id"
                  class="topix-ticket-item"
                  :class="{ 'topix-ticket-active': ticket.id === activeTicketId }"
                  @click="$emit('select', ticket.id)"
                >
                  <div class="topix-ticket-row">
                    <div class="topix-ticket-photo-wrap">
                      <img
                        v-if="ticket.authorPhotoUrl && !photoErrors[ticket.id]"
                        class="topix-ticket-photo"
                        :src="ticket.authorPhotoUrl"
                        alt=""
                        @error="onPhotoError(ticket.id)"
                      />
                      <div v-else class="topix-ticket-photo topix-ticket-photo--placeholder">
                        {{ initials(ticket.authorName) }}
                      </div>
                    </div>
                    <div class="topix-ticket-info">
                      <div class="topix-ticket-name">{{ ticket.authorName || 'Usuario' }}</div>
                      <div class="topix-ticket-category text-truncate">
                        {{ ticket.categoryLabel }} · {{ ticket.statusLabel }}
                      </div>
                    </div>
                  </div>
                </li>
                <li v-if="!filteredTickets.length" class="py-4 text-center text-muted small">
                  No hay tickets con ese criterio.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SupportTicketSidebar',
  props: {
    tickets: { type: Array, default: () => [] },
    activeTicketId: { type: String, default: '' },
    authorType: { type: String, required: true },
    sidebarTitle: { type: String, required: true },
    loading: { type: Boolean, default: false },
    loadError: { type: String, default: '' },
  },
  emits: ['select'],
  data() {
    return {
      search: '',
      photoErrors: {},
    };
  },
  computed: {
    filteredTickets() {
      const q = this.search.toLowerCase();
      if (!q) return this.tickets;
      return this.tickets.filter((ticket) => {
        const haystack = [
          ticket.authorName,
          ticket.authorEmail,
          ticket.categoryLabel,
          ticket.description,
          ticket.id,
        ]
          .filter(Boolean)
          .join(' ')
          .toLowerCase();
        return haystack.includes(q);
      });
    },
  },
  methods: {
    initials(name) {
      const parts = String(name || '?')
        .trim()
        .split(/\s+/)
        .filter(Boolean);
      return parts
        .slice(0, 2)
        .map((p) => p[0]?.toUpperCase() || '')
        .join('') || '?';
    },
    onPhotoError(id) {
      this.photoErrors = { ...this.photoErrors, [id]: true };
    },
  },
};
</script>

<style scoped>
.topix-support-sidebar-icon {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(39, 50, 120, 0.12);
  color: #273278;
  flex-shrink: 0;
}

.topix-ticket-list {
  padding: 0;
  margin: 0;
}

.topix-ticket-item {
  cursor: pointer;
  padding: 10px 8px;
  border-radius: 10px;
  list-style: none;
}

.topix-ticket-item:hover {
  background: rgba(0, 0, 0, 0.03);
}

.topix-ticket-active {
  background: rgba(39, 50, 120, 0.1);
}

.topix-ticket-row {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.topix-ticket-photo-wrap {
  flex-shrink: 0;
}

.topix-ticket-photo {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  object-fit: cover;
  display: block;
}

.topix-ticket-photo--placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #273278, #4a5aa8);
  color: #fff;
  font-weight: 700;
  font-size: 0.8rem;
}

.topix-ticket-info {
  min-width: 0;
  flex: 1;
}

.topix-ticket-name {
  font-weight: 600;
  color: #2c323f;
  line-height: 1.3;
  margin-bottom: 2px;
}

.topix-ticket-category {
  font-size: 12px;
  color: #6c757d;
}
</style>
